<template>
  <va-card :title="$t('menu.load_sequence')">
    <div class="row">
      <div class="flex xs2">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="delivery_date"
        />
      </div>

      <div class="flex" style="margin-left: -20px">
        <va-button
          small
          color="secondary"
          icon="fa fa-eraser"
          class="ma-2"
          @click="clear(delivery_date)"
        >
          {{ $t('menu.clear') }}
        </va-button>
      </div>

      <div class="flex xs3">
        <va-select
          v-model="loadType"
          :options='loadTypes'
          label="Tipo de Carga"
          textBy="name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione o tipo de carga"
        />
      </div>
      <div class="flex xs2">
        <va-input
          v-model="searchName"
          :label="$t('menu.search')"
          removable
        >
        </va-input>
      </div>

      <div class="flex xs12 md2">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>
      <div class="flex xs2">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
      <div class="flex xs2">
        <va-button
          small
          inline
          color="secondary"
          icon="fa fa-check"
          class="mr-1"
          @click="showConfirmAllFinishedLoad = true, deliveryDate = delivery_date"
        >
          {{ $t('menu.finish_all') }}
        </va-button>
      </div>
    </div>
    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      v-if="renderComponent"
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      no-pagination
      api-mode
      @page-selected="readItems"
    >
    <template slot="actions" slot-scope="props">
      <va-button
        small
        inline
        color="secondary"
        icon="fa fa-check"
        class="mr-1"
        @click="showConfirmFinishedLoad = true, codeLoadSequence = props.rowData.id"
        v-if="props.rowData.load_step >= 4 && props.rowData.load_step != 5 && props.rowData.load_step != 6"
      >
        {{ $t('menu.finish') }}
      </va-button>

      <template v-if="ability.can('sequence', 'Loads')">
        <va-button
          small
          inline
          color="secondary"
          icon="fa fa-check"
          class="mr-1"
          @click="sequenceLoad(props.rowData.id)"
          v-if="props.rowData.status_id === 14"
        >
          {{ $t('menu.sequence_load') }}
        </va-button>
      </template>
        <va-button
        small
        inline
        color="dark"
        icon="fa fa-list-alt"
        class="ma-0"
        :to="{ name: 'lists-load-table', params: { loadID: props.rowData.id, assemblyLine: 11, loadCode: props.rowData.code, delivery_date: delivery_date, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.lists') }}
      </va-button>
      <va-button
          small
          inline
          color="secondary"
          icon="fa fa-download"
          class="mr-1"
          @click="showConfirmExportSortedProduct = true, codeLoadSequence = props.rowData.id"
          v-if="props.rowData.status_id === 15"
        >
          {{ $t('menu.export_sorted_products') }}
        </va-button>
      <va-button v-if="ability.can('update', 'LoadSequence')"
          small
          inline
          color="green"
          icon="fa fa-edit"
          class="mr-1"
          :to="{ name: 'form-sequence-load', params: { load_id: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, current_page: current_page, searchName: searchName, perPage: perPage } }"
        >
          {{ $t('menu.edit') }}
      </va-button>
      <template v-if="ability.can('refuse', 'Loads')">
        <va-button
          small
          inline
          color="green"
          icon="fa fa-remove"
          class="mr-1"
          @click="showConfirmRefuseLoad = true, codeLoadSequence = props.rowData.id"
          v-if="props.rowData.status_id === 14"
        >
          {{ $t('tables.refuse') }}
        </va-button>
      </template>
      <template v-if="ability.can('reset_sequence', 'Loads')">
        <va-button
          small
          outline
          color="secondary"
          icon="fa fa-times"
          class="ma-0"
          @click="showConfirmResetSequence = true, codeLoadSequence = props.rowData.id"
          v-if="props.rowData.status_id === 15"
        >
          {{ $t('menu.reset_sequence') }}
        </va-button>
      </template>
    </template>
    </va-data-table>

      <Pagination
        :currentPage="current_page"
        :totalPages="totalPages"
        :onChange="onPageChange"
        v-show="!loading"
      />
      <va-modal
          v-model="showConfirmAllFinishedLoad"
          size="small"
          :title="$t('modal.confirm')"
          :message="$t('modal.showConfirmAllFinishedLoad')"
          hideDefaultActions
          :color="this.$themes.secondary"
        >

        <va-button
          color="danger"
          class="ma-2"
          @click="showConfirmAllFinishedLoad = false">
          {{$t('modal.cancel')}}
        </va-button>

        <va-button
          color="green"
          class="ma-2"
          @click="finishAllLoadsByOperator(deliveryDate), showConfirmAllFinishedLoad = false">
          {{$t('modal.confirm')}}
        </va-button>
      </va-modal>

      <va-modal
          v-model="showConfirmRefuseLoad"
          size="small"
          :title="$t('modal.confirm')"
          :message="$t('modal.showConfirmRefuseLoad')"
          hideDefaultActions
          :color="this.$themes.secondary"
        >
        <va-button
          color="danger"
          class="ma-2"
          @click="showConfirmRefuseLoad = false">
          {{$t('modal.cancel')}}
        </va-button>

        <va-button
          color="secondary"
          class="green"
          @click="refuseLoad(codeLoadSequence), showConfirmRefuseLoad = false">
          {{$t('modal.confirm')}}
        </va-button>
      </va-modal>

      <va-modal
          v-model="showConfirmFinishedLoad"
          size="small"
          :title="$t('modal.confirm')"
          :message="$t('modal.showConfirmFinishedLoad')"
          hideDefaultActions
          :color="this.$themes.secondary"
        >
        <va-button
          color="danger"
          class="ma-2"
          @click="showConfirmFinishedLoad = false">
          {{$t('modal.cancel')}}
        </va-button>
        <va-button
          color="secondary"
          class="green"
          @click="finishLoadByOperator(codeLoadSequence), showConfirmFinishedLoad = false">
          {{$t('modal.confirm')}}
        </va-button>
      </va-modal>

      <va-modal
        v-model="showConfirmResetSequence"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmSequenceLoadSequence')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >

      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmResetSequence = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="resetSequence(codeLoadSequence), showConfirmResetSequence = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

    <va-modal
        v-model="showConfirmExportSortedProduct"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmExportSortedProduct')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmExportSortedProduct = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="ExportSortedProducts(codeLoadSequence), showConfirmExportSortedProduct = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

  </va-card>
</template>

<script>

import LoadSequenceAPI from '@/services/LoadSequenceAPI'
import LoadAPI from '@/services/LoadAPI'
import moment from 'moment'
import * as spinners from 'epic-spinners'
import LoadTypeAPI from '@/services/LoadTypeAPI'
import { showError } from '@/global'
import { mapState } from "vuex";
import { Ability } from '@casl/ability'
export const ability = new Ability()

import Pagination from '../../shared/Pagination'

export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination
  },
  data () {
    return {
      ability: [],
      data: [],
      loading: false,
      delivery_date: '',
      showModal: false,
      showConfirmResetSequence: false,
      showConfirmRefuseLoad: false,
      showConfirmFinishedLoad: false,
      showConfirmAllFinishedLoad: false,
      showConfirmExportSortedProduct: false,
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      page: 1,
      perPage: '',
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      searchName: "",
      current_page: '',
      renderComponent: true,
      last_refresh: new Date(),
      loadType: {
        id: '',
        name: ''
      },
      loadTypes: [],
      filepath: "",
    }
  },

  channels: {
    NeedRefreshLoads: {
      received(data) {
        const last_received_refresh = ( new Date() - this.last_refresh) / 1000

        if (last_received_refresh >= 30) {
          this.last_refresh = new Date()
          this.readItems()
        }
      }
    }
  },

  beforeMount(){
    this.ability = ability.update(this.rules)
  },

  mounted () {

    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })

    // this.perPage = (this.$route.params.perPage !== undefined) ? `${this.$route.params.perPage}` : "10"
    this.searchName = (this.$route.params.searchName !== undefined) ? `${this.$route.params.searchName}` : ""

    if (this.$route.params.delivery_date !== undefined) {
      this.delivery_date = `${this.$route.params.delivery_date}`
    } else {
      this.readDeliveryDate(this.currentLocality.id)
    }

    this.getDefaultLoadType()

    this.readItems(this.$route.params.current_page, this.searchName)
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {

      return [{
        name: 'id',
        title: this.$t('tables.load_sequence.id'),
        width: '3%',
      },
      {
        name: 'load_sequence',
        title: this.$t('tables.load_sequence.sequence'),
        width: '2%',
        dataClass: 'text-center',
      },
      {
        name: 'user',
        title: this.$t('tables.load_sequence.conferent'),
        width: '10%',
      },
      {
        name: 'dock',
        title: this.$t('tables.orders.dock'),
        width: '5%',
      },
      {
        name: 'locality',
        title: this.$t('tables.load_sequence.locality_name'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.load_sequence.code'),
      },
      {
        name: 'vehicle',
        title: this.$t('tables.loads.vehicle'),
      },
      {
        name: 'weight',
        title: this.$t('tables.loads.weight'),
      },
      {
        name: 'quantity_orders',
        title: this.$t('tables.loads.quantity_orders'),
      },
      {
        name: 'quantity_boxes',
        title: this.$t('tables.loads.quantity_boxes'),
      },
      {
        name: 'delivery_date',
        title: this.$t('tables.loads.delivery_date'),
      },
      {
        name: 'assembled_percentage',
        title: this.$t('tables.loads.assembled_percentage'),
        dataClass: 'text-center',
      },
      {
        name: 'checked_percentage',
        title: this.$t('tables.loads.checked_percentage'),
        dataClass: 'text-center',
      },
      {
        name: 'loaded_percentage',
        title: this.$t('tables.loads.loaded_percentage'),
        dataClass: 'text-center',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
        width: '45%',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems()
      }
    },
    delivery_date: function (newVal) {
      this.readItems()
    },
    loadType: function (newVal) {
      this.readItems()
    },

    '$store.state.currentLocality': function() {
      this.readItems()
    }
  },
  methods: {
    ExportSortedProducts (loadId) {
      LoadAPI.exportSortedProducts(loadId, this.currentLocality.id).then(response => {
        this.forceRerender()
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    onPageChange(page) {
      this.readItems(page)
    },
    clear (field) {
      this.delivery_date = ""
    },
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    async readItems(page = 1, searchName) {
      this.loading = true

      await LoadTypeAPI.getAllLoadTypes().then(response => {
        this.loadTypes = response.data.load_types
      }).catch(e => {
        showError(e)
      });

      const params = {
        page: page,
        quantity: this.perPage,
        search: this.searchName,
        delivery_date: this.delivery_date,
        locality: this.currentLocality.id,
        load_type_id: this.loadType.id
      }
      this.current_page = this.$route.params.current_page

      await LoadSequenceAPI.getFilteredLoads(params)
      .then(response => {
        this.data = response.data.loads
        this.totalPages = response.data.total_pages
        // this.delivery_date = (this.$route.params.delivery_date !== undefined) ? `${this.$route.params.delivery_date}` : response.data.last_delivery_date
        this.current_page = response.data.current_page
        this.loading = false
      }).catch(e => {
        this.loading = false
        showError(e)
      });
    },
    async readDeliveryDate (localityId) {
      await LoadSequenceAPI.getLastDeliveryDate(localityId).then(response => {
        this.delivery_date = response.data.last_delivery_date
      }).catch(e => {
        showError(e)
      });
    },
    async getDefaultLoadType () {
      await LoadTypeAPI.getDefaultLoadType().then(response => {
        this.loadType = response.data.load_type
      }).catch(e => {
        showError(e)
      });
    },
    async sequenceLoad (loadID) {
      this.loading = true
      await LoadSequenceAPI.sequenceLoad(loadID).then(response => {

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    async resetSequence (loadID) {
      this.loading = true
      await LoadSequenceAPI.resetSequence(loadID).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    async refuseLoad (loadID) {
      this.loading = true
      await LoadSequenceAPI.refuseLoad(loadID).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    async finishLoadByOperator (loadId) {
      this.loading = true
      await LoadSequenceAPI.finishLoadByOperator(loadId).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    async finishAllLoadsByOperator (deliveryDate) {
      this.loading = true
      await LoadSequenceAPI.finishAllLoadsByOperator(deliveryDate, this.currentLocality.id).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
  },
}
</script>
